import React, { useMemo } from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'

import DateRangePicker from '../../../projects/components/DateRangePicker'
import { REPORTING_DATE_DISPLAY_FORMAT } from '../../reporting.constants'
import {
    REPORTING_PERIOD,
    REPORTING_PERIOD_OPTIONS,
    getReportingDateRangeForPeriod,
    toReportingDateTimestamp,
} from '../workload.utils'

import styles from '../WorkloadDashboard.module.css'

const WorkloadPeriodControls = ({
    periodType,
    start,
    end,
    onPeriodChange,
    onPresetRangeChange,
    onCustomRangeChange,
}) => {
    const anchorDate = useMemo(() => {
        if (start != null) {
            const d = dayjs(start)
            if (d.isValid()) return d
        }
        return dayjs()
    }, [start])

    const customPickerValue = useMemo(
        () => ({
            start: toReportingDateTimestamp(start, 'start'),
            end: toReportingDateTimestamp(end, 'end'),
        }),
        [start, end]
    )

    const pickerMode = periodType === REPORTING_PERIOD.DAY ? 'date' : periodType

    return (
        <div className={styles.periodControlsGroup}>
            <div
                className={styles.periodToggle}
                role="group"
                aria-label="Reporting period"
            >
                {REPORTING_PERIOD_OPTIONS.map((opt) => (
                    <button
                        key={opt.value}
                        type="button"
                        className={`${styles.periodBtn} ${
                            periodType === opt.value
                                ? styles.periodBtnActive
                                : ''
                        }`}
                        onClick={() => onPeriodChange(opt.value)}
                    >
                        {opt.label}
                    </button>
                ))}
            </div>

            {periodType === REPORTING_PERIOD.CUSTOM ? (
                <div className={styles.dateFilterWrap}>
                    <DateRangePicker
                        value={customPickerValue}
                        onChange={onCustomRangeChange}
                        placeholder="Date range"
                        parentComponent="taskDetailView"
                        dateFormat={REPORTING_DATE_DISPLAY_FORMAT}
                        showClear={false}
                    />
                </div>
            ) : (
                <div className={styles.dateFilterWrap}>
                    <DatePicker
                        allowClear={false}
                        picker={pickerMode}
                        format={REPORTING_DATE_DISPLAY_FORMAT}
                        className={styles.periodDatePicker}
                        value={anchorDate}
                        onChange={(date) => {
                            if (!date?.isValid?.()) return
                            onPresetRangeChange(
                                getReportingDateRangeForPeriod(periodType, date)
                            )
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default WorkloadPeriodControls
